import { useMemo } from "react";
import { jwtDecode } from "jwt-decode";
import { useAuth } from "../auth/AuthProvider";

export function useCustomerId(token?: string | null): string | null {
  const { devOverrides } = useAuth();

  return useMemo(() => {
    // In development with override, use that
    if (process.env.NODE_ENV === 'development' && devOverrides?.customerId) {
      return devOverrides.customerId;
    }

    // Otherwise extract from token
    try {
      if (!token) return null;
      const decoded = jwtDecode<{ customer_id?: string }>(token);
      return decoded.customer_id || null;
    } catch {
      return null;
    }
  }, [token, devOverrides]);
}
